import { TopBannerMessage } from '@post-office/jira-common/components/top-banner-message';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';

import { createRender } from './types';

export const render = createRender(() => <TopBannerMessage />);

export default render;
